import { useNavigate } from "react-router-dom";
import { el, hashText } from "../util";
import { Component } from "react";

export function ExternalLink({ href, children }) {
  return <a href={href}
            className="hover:underline pr-6 bg-right bg-[url(/public/img/external.svg)] bg-no-repeat">
    {children}
  </a>
}

/**
 * @param {Object} param0
 * @param {*} param0.children
 * @param {string} param0.className
 */
export function Card({children, className}) {
  return <div className={["rounded shadow shadow-slate-400", className].join(" ")}>
    {children}
  </div>
}

export function CopyOnHover({text, title="Copy", children, className}) {
  return <div className={["flex flex-row items-center group/coh", className].join(" ")}>
    {children}
    <CopyButton
      value={text}
      title={title}
      className="
        hidden group-hover/coh:block
        h-4 aspect-square hover:scale-110"
        />
  </div>
}

/**
 *
 * @param {Object} param0
 * @param {*} param0.value value to write to clipboard
 * @param {string} param0.title
 * @param {string} param0.className
 * @returns
 */
export function CopyButton({value, title, className}) {
  return <button title={title}
      type="button"
      onClick={() => navigator.clipboard.writeText(value)}
      className={["bg-[url(/public/img/copy.svg)] bg-no-repeat",className].join(" ")} >
    </button>
}
/**
 *
 * @param {Object} param0
 * @param {string} param0.href
 * @param {string} param0.title
 * @param {boolean} param0.external set to true to open in new tab
 * @param {string} param0.className
 * @returns
 */
export function NavigateButton({href, title, external=false, className}) {
  return <a href={href}
            title={title}
            target={external ? "new" : undefined}
            className={["", className].join(" ")}></a>
}

/**
 *
 * @param {Object} param0
 * @param {string} param0.href
 * @param {string} param0.fileName
 * @param {string} param0.title
 * @param {string} param0.className
 * @returns
 */
export function DownloadButton({href, fileName, title="Download", className}) {
  return <a download={fileName}
            href={href}
            title={title}
            className={["", className].join(" ")}
            ></a>
}

export function Expandable({ children, className }) {
  class _Expandable extends Component {
    constructor(...args) {
      super(...args);
      this.WRAPPER_ID = crypto.randomUUID();
      this.CONTAINER_ID = crypto.randomUUID();
      this.ANCHOR_ID = crypto.randomUUID();
      this.isExpanded = false;
    }
    componentDidMount() {
      let listWrapper = el(this.WRAPPER_ID)
      this.minHeight = getComputedStyle(listWrapper).minHeight;
      if (!this.minHeight || this.minHeight == "0px") {
        this.minHeight = "fit";
      }
      this.maxHeight = getComputedStyle(listWrapper).maxHeight;
      if (!this.maxHeightH || this.maxHeight == "none") {
        this.maxHeight = "100%";
      }
      this.isExpandedHook();
      let listContainer = el(this.CONTAINER_ID);
      this.isOverflowing = listContainer.scrollHeight > listContainer.clientHeight
      if (!this.isOverflowing) {
        el(this.ANCHOR_ID).classList.add("hidden")
      }
    }
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      this.isExpandedHook();
    }
    isExpandedHook() {
      let listContainerStyle = el(this.CONTAINER_ID).style;
      listContainerStyle.overflowY = this.isExpanded ? "auto" : "hidden";
      listContainerStyle.height = this.isExpanded ? this.maxHeight : this.minHeight;
      el(this.ANCHOR_ID).innerText = `Show ${this.isExpanded ? "less" : `all ${children.length}`}`;
    }

    render() {
      let doClick = (_) =>{
        if (this.isExpanded) el(this.CONTAINER_ID).scrollTo({ top: 0 });
        this.toggleExpanded();
      }
      return <div id={this.WRAPPER_ID} className={["flex flex-col max-w-fit", className].join(" ")}>
        <div id={this.CONTAINER_ID}> {children} </div>
        <a id={this.ANCHOR_ID} onClick={doClick}
           className="font-sans cursor-pointer hover:underline hover:text-blue-500 text-blue-600" >
        </a>
      </div>;
    }
  }

  return <_Expandable />;
}

export function FlexRowPair({ kv }) {
  const [k, v] = kv;
  return (
    <div className="flex flex-row">
      <div className="grow text-left">{k}</div>
      <div className="grow text-right ml-2">{v}</div>
    </div>
  );
}

/**
 * @param {Object} param0
 * @param {*} param0.obj
 * @param {string} param0.className  */
export function FlexObject({ obj, className }) {
  return <div className={["flex flex-col font-mono", className].join(" ")}>
    {Object.entries(obj).map(e=> <FlexRowPair key={e[0]} kv={e}/>)}
  </div>
}

/**
 * @param {Object} param0
 * @param {Array[]} param0.entries
 * @param {Function} param0.keyfn
 * @param {string} param0.className
 */
export function FlexRowTupleArray({ entries, keyfn, className }) {
  return <div className={["flex flex-col font-mono", className].join(" ")}>
    {entries.map(e => <FlexRowPair key={keyfn ? keyfn(e) : e[0]} kv={e} />)}
  </div>
}

export function HashText({ h }) {
  if (!h) return (<></>)
  return (
    <span title={h}>
          {hashText(h)}
    </span>
  );
}

export function HashDisplay({ h, fontSize }) {
  // TODO: make a new namespace: Components/Hash
  return (
    <div className="flex flex-row max-w-fit select-none">
      <div title={h}
        className="pr-0.5 text-left truncate w-fit font-mono" style={{ fontSize }}>
        {hashText(h)}
      </div>
      <button title="Copy hash"
        type="button"
        onClick={() => navigator.clipboard.writeText(h)}
        className="~hidden group-hover/address:block rounded-sm active:backdrop-brightness-90 min-w-fit w-4 h-4 bg-no-repeat hover:bg-[url(/public/img/copy.svg)]">
      </button>
    </div>
  );
}

export function Hash({ h }) {
  // Deprecated
  if (!h) return (<></>)
  const hashId = `${h}_${Math.ceil(Math.random() * 1000000)}`; // to "ensure" unique id of button
  // I'd love to know of a method to reference "this" in onClick props other than this
  function short(h) {
    return `${h.slice(0, 2)}|${h.slice(2, 18)}…`;
  }
  function long(h) {
    return `${h.slice(0, 2)}|${h.slice(2)}`;
  }
  const clickColor = "bg-slate-100"
  return ( // todo make this a div, so that we can control the layout span is too loose
    <div title={h} className="flex flex-row select-none">
      <button id={`btn_expand_${hashId}`}
        type="button"
        onMouseDown={() => document.getElementById(`btn_expand_${hashId}`).innerText = long(h)}
        onMouseUp={() => document.getElementById(`btn_expand_${hashId}`).innerText = short(h)} >
        {short(h)}
      </button>
      <button id={`btn_copy_${hashId}`}
        type="button"
        className="rounded p-1"
        data
        onMouseDown={() => document.getElementById(`btn_copy_${hashId}`).classList.add(clickColor)}
        onMouseUp={() => document.getElementById(`btn_copy_${hashId}`).classList.remove(clickColor)}
        onMouseLeave={() => document.getElementById(`btn_copy_${hashId}`).classList.remove(clickColor)}
        onMouseDownCapture={() => navigator.clipboard.writeText(h)} >

        {/* TODO: put this in a file or something */}
        <svg className="fill-slate-800 h-3" viewBox="0 0 352.804 352.804" id="copy-svg" >
          <g>
            <path d="M318.54,57.282h-47.652V15c0-8.284-6.716-15-15-15H34.264c-8.284,0-15,6.716-15,15v265.522c0,8.284,6.716,15,15,15h47.651
		v42.281c0,8.284,6.716,15,15,15H318.54c8.284,0,15-6.716,15-15V72.282C333.54,63.998,326.824,57.282,318.54,57.282z
		 M49.264,265.522V30h191.623v27.282H96.916c-8.284,0-15,6.716-15,15v193.24H49.264z M303.54,322.804H111.916V87.282H303.54V322.804
		z"/>
          </g>
        </svg>
      </button>
    </div>
  );
}


export function HashList({ hl }) { // Hash is deprecated use HashDisplay instead
  if (!hl) return (<></>);
  if (hl.length == 0) return (<ul></ul>);
  return (
    <ul>
      {hl.map((h) => <li key={h}><Hash h={h} /></li>)}
    </ul>
  );
}



export function FileHash({h}) {
  // TODO: lots of duplication from Hash component; opportunity for factorization?
  // TODO: Hash is deprecated use HashDisplay instead
  // FIXME(sfertman): do not use get by id; can be done with css
  if (!h) return (<></>)
  const hashId = `${h}_${crypto.randomUUID()}`; // to "ensure" unique id of button
  // I'd love to know of a method to reference "this" in onClick props other than this
  const clickColor = "bg-slate-100"
  const navigate = useNavigate();
  return (
    <span title={h}>
      <button id={`btn_navigate_${hashId}`}
        type="button"
        onClick={()=>navigate(`/file/${h}`)}
        >
        {h.slice(0, 8)}
      </button>
      <button id={`btn_copy_${hashId}`}
        type="button"
        className="rounded p-1 border-slate-500"
        data
        onMouseDown={() => document.getElementById(`btn_copy_${hashId}`).classList.add(clickColor)}
        onMouseUp={() => document.getElementById(`btn_copy_${hashId}`).classList.remove(clickColor)}
        onMouseLeave={() => document.getElementById(`btn_copy_${hashId}`).classList.remove(clickColor)}
        onMouseDownCapture={() => navigator.clipboard.writeText(h)} >

        {/* TODO: put this in a file or something */}
        <svg className="fill-slate-800 h-3" viewBox="0 0 352.804 352.804" id="copy-svg" >
            <path d="M318.54,57.282h-47.652V15c0-8.284-6.716-15-15-15H34.264c-8.284,0-15,6.716-15,15v265.522c0,8.284,6.716,15,15,15h47.651
		v42.281c0,8.284,6.716,15,15,15H318.54c8.284,0,15-6.716,15-15V72.282C333.54,63.998,326.824,57.282,318.54,57.282z
		 M49.264,265.522V30h191.623v27.282H96.916c-8.284,0-15,6.716-15,15v193.24H49.264z M303.54,322.804H111.916V87.282H303.54V322.804
		z"/>
        </svg>
      </button>
    </span>
  );
}

export function FileHashList({hl}) {
  if (!hl) return (<></>);
  if (hl.length == 0) return (<ul></ul>);
  return (
    <ul>
      {hl.map((h) => <li key={h}><FileHash h={h} /></li>)}
    </ul>
  );

}
